<div class="t-screen" id="root" [style.zoom]="zoom">
  <app-screenshot-header [settings]="screenshot.settings" />
  <app-screenshot-content [screenshot]="screenshot" />
  <app-screenshot-footer [settings]="screenshot.settings" />
  <img [src]="screenshot.settings.hero.backgroundUrl" sizes="(max-width: 828px) 100vw, 828px" class="t-bg" alt="" loading="lazy" />
</div>
